import type { ReactNode } from 'react';

import { Wrapper } from './Eyebrow.parts';

export type EyebrowProps = {
	children: ReactNode;
	className?: string;
};

export function Eyebrow(props: EyebrowProps) {
	return <Wrapper className={props.className}>{props.children}</Wrapper>;
}
